import { Injectable } from "@angular/core";
import { RenderContext } from "./webgl-context";
import { FragmentShader } from "./fragment-shader";
import { VertexShader } from "./vertex-shader";
var ShaderProgram = (function () {
    function ShaderProgram(gl_, fragment_shader_, vertex_shader_) {
        this.gl_ = gl_;
        this.fragment_shader_ = fragment_shader_;
        this.vertex_shader_ = vertex_shader_;
    }
    ;
    ShaderProgram.prototype.initWebGl = function () {
        var gl = this.gl_.context;
        this.initProgram(gl);
        this.initVertexArrays(gl);
        gl.clearColor(0.5, 0.5, 0.5, 1.0);
        gl.clearDepth(1.0);
        gl.enable(gl.DEPTH_TEST);
        gl.depthFunc(gl.LEQUAL);
    };
    ;
    ShaderProgram.prototype.initProgram = function (gl) {
        var vertShader = this.vertex_shader_.getShader(gl);
        var fragShader = this.fragment_shader_.getShader(gl);
        this.program_ = gl.createProgram();
        gl.attachShader(this.program_, vertShader);
        gl.attachShader(this.program_, fragShader);
        gl.linkProgram(this.program_);
        if (!gl.getProgramParameter(this.program_, gl.LINK_STATUS)) {
            gl.deleteProgram(this.program_);
            gl.deleteShader(vertShader);
            gl.deleteShader(fragShader);
            alert("Unable to initialize the shader program.");
        }
        gl.detachShader(this.program_, vertShader);
        gl.detachShader(this.program_, fragShader);
        gl.deleteShader(vertShader);
        gl.deleteShader(fragShader);
        gl.useProgram(this.program_);
        this.uView_ = gl.getUniformLocation(this.program_, "uView");
        this.uProjection_ = gl.getUniformLocation(this.program_, "uProjection");
        this.uTransform_ = gl.getUniformLocation(this.program_, "uTransform");
        this.uSampler_ = gl.getUniformLocation(this.program_, "uSampler");
    };
    ;
    ShaderProgram.prototype.initVertexArrays = function (gl) {
        this.aVertexPosition_ = gl.getAttribLocation(this.program_, "aVertexPosition");
        gl.enableVertexAttribArray(this.aVertexPosition_);
        this.aNormals_ = gl.getAttribLocation(this.program_, "aNormal");
        gl.enableVertexAttribArray(this.aNormals_);
    };
    ;
    Object.defineProperty(ShaderProgram.prototype, "aVertexPosition", {
        get: function () { return this.aVertexPosition_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShaderProgram.prototype, "aNormals", {
        get: function () { return this.aNormals_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShaderProgram.prototype, "uView", {
        get: function () { return this.uView_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShaderProgram.prototype, "uProjection", {
        get: function () { return this.uProjection_; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShaderProgram.prototype, "uTransform", {
        get: function () { return this.uTransform_; },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    Object.defineProperty(ShaderProgram.prototype, "uSampler", {
        get: function () { return this.uSampler_; },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    ShaderProgram.decorators = [
        { type: Injectable },
    ];
    ShaderProgram.ctorParameters = function () { return [
        { type: RenderContext, },
        { type: FragmentShader, },
        { type: VertexShader, },
    ]; };
    return ShaderProgram;
}());
export { ShaderProgram };
//# sourceMappingURL=webgl-program.js.map